export default "__VITE_ASSET__2XzeBVDf__"